import { FormGroup } from "@angular/forms"
import { OrderWizardService } from "../../../_service/order-wizard.service"
import { CommonModule } from "@angular/common"
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core"
import { PickupPointDto } from "../../../../model/pickup-point.model"
import { CorpCardComponent } from "@corporate-tailwind/component"
import { TranslateModule } from "@ngx-translate/core"

@Component({
    selector: 'pickup-point-card',
    imports: [CommonModule, CorpCardComponent, TranslateModule],
    templateUrl: './pickup-point-card.component.html',
    styleUrls: ['./pickup-point-card.component.scss'],
    animations: []
})
export class PickupPointCardComponent implements OnInit, OnDestroy {
    @Input() selectedId: number | null = null;
    @Output() selectedIdChange = new EventEmitter<number | null>();

    @Input() pickupPoint: PickupPointDto | null = null;

    form: FormGroup | null = null;
    loaded = false;

    constructor(
        public _orderWizardService: OrderWizardService
    ) {
        this.form = this._orderWizardService.formGroup

    }

    ngOnInit(): void {
        setTimeout(() => {
            this.loaded = true
        })
    }

    ngOnDestroy(): void {

    }

    select(id: number) {
        this.selectedId == id
            ? this.selectedId = null
            : this.selectedId = id

        this.selectedIdChange.emit(this.selectedId)
    }

    GetSelectedPickupPoint(id: number | null): PickupPointDto | null {
        if (id === null) {
            return null
        }
        const pickupPoints = this._orderWizardService.selection$()?.pickupPoint
        return pickupPoints?.find(pp => pp.place?.id === id) || null
    }


    getPickupPointUrlImage(pickupPoint: PickupPointDto | null): string {
        const key = pickupPoint?.place?.label
        if (key == null)
            return ''

        const normalized = key
            .toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // supprime les accents
            .replace(/[^a-z0-9]+/g, '_')                      // remplace les caractères spéciaux par _
            .replace(/^_+|_+$/g, '')                          // trim les _ en début/fin
        //console.log('normalized : ', normalized)
        return `images/card/${normalized}.png`
        //return `images/card/${normalized}__${pickupPoint?.place?.code}.png`
    }
}
